import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/rem'
import store from './stores/store'
import { Select, Option, Pagination, Drawer } from 'element-ui';
import plugin from "./plugins/index"
Vue.use(plugin,router)

Vue.use(Select)
Vue.use(Option)
Vue.use(Pagination)
Vue.use(Drawer)

Vue.config.productionTip = false

let search = searchToMap();
if(search.token) localStorage.setItem("token",search.token)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')


function searchToMap(){
  let search = location.search.slice(1);
  let map = {};
  if(search){
    let _searchs = search.split('?');
    _searchs.forEach(_s=>{
      let _array =_s.split('&');
      _array.forEach(str => {
        let _str = str.split('=');
        map[_str[0]] = _str[1];
      });
    })
  }
  return map;
}